import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dialog } from "primereact/dialog";
import Langs from "../../app/lang/langs";
import { InputField } from "../../components/inputs/InputField";
import { DynamicButton } from "../../components/buttons/DynamicButton";
import { Row } from "primereact/row";
import { Col } from "react-bootstrap";
import { doneVisitsStatuses, getAllMedicalVisits, medicalVisitsTypesOptions, upcomingVisitsStatuses, updateMedicalVisit } from "./medicalVisistsSlice";
import moment from "moment";
import { Tag } from "primereact/tag";

export default function ViewMedicalVisitModal(props) {

    const dispatch = useDispatch()
    const isMobile = useSelector((state) => state.settings.isMobile)
    const [updatedItem, setUpdatedItem] = useState(props.selectedMedicalVisit)
    useEffect(() => { console.log(updatedItem) }, [updatedItem])
    const handleFieldChange = (value, field) => {
        setUpdatedItem(prev => ({
            ...prev,
            [field.key]: value
        }))
    }

    useEffect(() => {
        setUpdatedItem({
            ...props.selectedMedicalVisit
        })
    }, [props.selectedMedicalVisit])

    const conclusionBodyTemplate = (option) => {
        switch (option) {
            case "Apte":
                return <Tag value={<Langs str={option} />} severity="success" />
            case "Absent":
                return <Tag value={<Langs str={option} />} severity="danger" />
            case "Inapte":
                return <Tag value={<Langs str={option} />} />
            default:
                return <Tag value={option} severity="danger" />
        }
    }

    const visibleFields = [
        { key: "status", type: "dropdown", options: upcomingVisitsStatuses.concat(doneVisitsStatuses) },
        { key: "type", type: "dropdown", options: medicalVisitsTypesOptions["type"] },
        { key: "type_follow_up", type: "dropdown", options: medicalVisitsTypesOptions["type_follow_up"] },
        { key: "team_name", type: "string", disabled: true },
        { key: "medical_center", type: "dropdown", options: medicalVisitsTypesOptions["medical_center"] },
        { key: "conclusion", type: "dropdown", options: medicalVisitsTypesOptions["conclusion"], itemTemplate: conclusionBodyTemplate, valueTemplate: conclusionBodyTemplate },
        { key: "validation", type: "yes:no" },
        { key: "last_visit_date", type: "date:time", disabled: true },
        { key: "next_visit_date", type: "date:time" },
        { key: "theoretical_visit_date", type: "date:time" },
        { key: "planned_visit_date", type: "date:time" },
        { key: "sent_date", type: "date" },
        { key: "is_mid_career", type: "yes:no" },
        { key: "comments", type: "text" },
        { key: "created_at", type: "date:time", disabled: true },
        { key: "updated_at", type: "date:time", disabled: true }
    ]

    function getFormatDate(dateKey) {
        if (updatedItem[dateKey]) {
            return moment(updatedItem[dateKey], "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
        }
        return null
    }

    const handleSave = async () => {
        await dispatch(updateMedicalVisit({
            id: updatedItem["id"],
            status: updatedItem["status"],
            type: updatedItem["type"],
            type_follow_up: updatedItem["type_follow_up"],
            medical_center: updatedItem["medical_center"],
            comments: updatedItem["comments"],
            conclusion: updatedItem["conclusion"],
            theoretical_visit_date: getFormatDate("theoretical_visit_date"),
            next_visit_date: getFormatDate("next_visit_date"),
            planned_visit_date: getFormatDate("planned_visit_date")
        })).unwrap()

        props.onHide()
        dispatch(getAllMedicalVisits())
    }

    const footer = () => {
        if (JSON.stringify(props.selectedMedicalVisit) != JSON.stringify(updatedItem))
            return <Row className="d-flex justify-content-center" >
                <Col lg={2} xs={2}>
                    <DynamicButton
                        onClick={handleSave}
                        className='me-auto'
                        title={<Langs str="Save" />}
                        active={true}
                        color="green"
                    />
                </Col>
            </Row>
    }

    return (
        <Dialog
            visible={props.selectedMedicalVisit}
            style={{ width: isMobile === 2 ? "90%" : "50%" }}
            onHide={() => {
                props.onHide()
            }}
            header={updatedItem && `${updatedItem["title"]} ${updatedItem["prenom"]} ${updatedItem["nom"]} - ${updatedItem["type"]}`}
            draggable={false}
            dismissableMask={false}
            footer={footer}
        >
            {visibleFields.map(field => <InputField field={field}
                onChange={(e) => handleFieldChange(e, field)}
                value={updatedItem && updatedItem[field.key]} />
            )}
        </Dialog>
    )
}